import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableRow as MuiTableRow } from '@mui/material';
import { useTranslation } from '@zurich/common/hooks';
import { styled } from '../../utils';
import { TableCell } from './TableCell';
import { getStriped } from './TableRow';
const MinCell = styled(TableCell)(() => ({
    width: 0,
    whiteSpace: 'nowrap',
}));
export const TableHeaderRowStyled = styled(MuiTableRow)(({ theme }) => ({
    borderTop: `1px solid ${theme.palette.groupPrimary.lightBlue}`,
    cursor: 'pointer',
}));
export function TableHeadRow({ columns, isExpandable, showIndex, menuTitle, stripes = 'odd', cellPadding = 'default', alternativeCellAlignmentRight = false, size = 'default', }) {
    const { t } = useTranslation();
    return (_jsxs(TableHeaderRowStyled, { children: [isExpandable && (_jsx(TableCell, { cellPadding: cellPadding, cellSize: size, width: "40", className: "expandCell" })), showIndex && (_jsx(MinCell, { striped: getStriped(stripes, 1), cellPadding: cellPadding, cellSize: size, width: "0", children: t('common:table.indexLabel') })), columns.map((column, i) => column.label && (_jsx(TableCell, { cellPadding: cellPadding, cellSize: size, striped: getStriped(stripes, i), onClick: () => column.clicked?.(), align: alternativeCellAlignmentRight && i > 0 ? 'right' : undefined, children: column.label }, i))), menuTitle && (_jsx(MinCell, { cellSize: size, cellPadding: cellPadding, children: menuTitle }))] }));
}
